import React, { useState, useEffect } from 'react';

import { Dropdown, FormInput_text, FormInput_textarea, formInput_funcUtility, FormGroupRadio, Toaster } from "components";

import { func_validation, func_currency, func_data } from "functions";




export function useBillingInfo(props) {
    // Props
    const {
        isFormSubmissionAttempted
    } = props;
    
    // States
    const [billingStreet, setBillingStreet] = useState("");
    const [billingCity, setBillingCity] = useState("");
    const [billingState, setBillingState] = useState("");
    const [billingPostcode, setBillingPostcode] = useState("");
    const [billingCountry, setBillingCountry] = useState("");

    // Create List
    let countryDetails = func_data.getAllCountries();
    countryDetails = [];
    if (func_validation.isArrayNotEmpty(countryDetails)) {
        countryDetails.map((countryObj) => {
            return func_validation.getObjectPropertyValue(countryObj, "name");
        });
    }
    let countryList_formatted = func_validation.convertArrayToDropdownArrayFormat(countryDetails);

    let stateDetails = func_data.getStatesFromCountryId(132); // default is Malaysia
    stateDetails = stateDetails.map((stateObj) => {
        return func_validation.getObjectPropertyValue(stateObj, "name");
    });
    let stateList_formatted = func_validation.convertArrayToDropdownArrayFormat(stateDetails);

    let cityDetails = func_data.getCitiesFromStateId(2322); // default is Selangor
    cityDetails = cityDetails.map((stateObj) => {
        return func_validation.getObjectPropertyValue(stateObj, "name");
    });
    let cityList_formatted = func_validation.convertArrayToDropdownArrayFormat(cityDetails);

    // Display
    let display = (
        <div className="distributorPortal-clientRegistration-billingInfo ">

            <div className={"d-flex "}>
                {/* Billing Street */}
                <FormInput_text  
                    inputLabel={"Billing Street"}

                    className={"distributorPortal-clientRegistration-billingStreet"}
                    inputValue_default={billingStreet} 

                    isInputBlurHandlingRequired
                    handleInputBlurExtend={(value) => { setBillingStreet(value); }}

                    customErrorMsgDefault={"Required"}
                    isFormSubmissionAttempted={isFormSubmissionAttempted} 

                    isInputValueTrim_onChange
                    isMarginBtmOptional
                />
            </div>

            <div className={"d-flex "}>
                {/* Billing City */}
                <Dropdown
                    className={"distributorPortal-clientRegistration-billingCity"}
                    label={"Billing City"}

                    selectedValueClassName={"distributorPortal-clientRegistration-billingCity-input"}

                    options={cityList_formatted}
                    selectedValue_default={billingCity}
                    onChange={setBillingCity}

                    isFormSubmissionAttempted={isFormSubmissionAttempted} 

                    isSearchable
                    isInputValueTrim_onChange
                />

                {/* Billing State */}
                <Dropdown
                    className={"distributorPortal-clientRegistration-billingState"}
                    label={"Billing State"}

                    selectedValueClassName={"distributorPortal-clientRegistration-billingState-input"}

                    options={stateList_formatted}
                    selectedValue_default={billingState}
                    onChange={setBillingState}

                    isFormSubmissionAttempted={isFormSubmissionAttempted} 

                    isSearchable
                    isInputValueTrim_onChange
                />

                {/* Billing Postcode */}
                <FormInput_text  
                    inputLabel={"Billing Postcode"}

                    className={"distributorPortal-clientRegistration-billingPostcode"}
                    inputValue_default={billingPostcode} 

                    isInputBlurHandlingRequired
                    handleInputBlurExtend={(value) => { setBillingPostcode(value); }}

                    customErrorMsgDefault={"Required"}
                    isFormSubmissionAttempted={isFormSubmissionAttempted} 

                    isInputValueTrim_onChange
                    isMarginBtmOptional
                />

                {/* Billing Country */}
                <Dropdown
                    className={"distributorPortal-clientRegistration-billingCountry"}
                    label={"Billing Country"}

                    selectedValueClassName={"distributorPortal-clientRegistration-billingCountry-input"}

                    options={countryList_formatted}
                    selectedValue_default={billingCountry}
                    onChange={setBillingCountry}

                    isFormSubmissionAttempted={isFormSubmissionAttempted} 

                    isSearchable
                    isInputValueTrim_onChange
                />

            </div>

        </div>
    )

    return {
        billingStreet,
        billingCity,
        billingState,
        billingPostcode,
        billingCountry,
        
        display
    }
}